import { Popover } from "antd";

import { BasePopoverProps } from "./types";

const BasePopover = ({ children, ...props }: BasePopoverProps) => {
  return <Popover {...props}>{children}</Popover>;
};

export default BasePopover;
